import { Controller } from '@hotwired/stimulus';
import Cookies from 'js-cookie';
import { primeForPostLogin } from 'lib/helpers';
import {
  LOGIN_TRIGGERED,
  JOIN_TRIGGERED,
  COLLECTION_SAVE_CLICK,
} from 'components/analytics/conversions/constants/actions';
import { sendTrackingEvent } from 'components/analytics/conversions/tracking';

export default class CollectionSaveButtonController extends Controller {
  static targets = ['saveButton'];

  static values = {
    isPro: Boolean,
    contentType: String,
    sessionType: String,
  }

  connect() {
    if (Cookies.get('add_collection_after_login')) {
      const resourceID = Cookies.get('add_collection_after_login');

      this.findAndClickCollectionSaveButton(resourceID);

      Cookies.remove('add_collection_after_login');
    }
  }

  trackClick(event) {
    sendTrackingEvent({
      element: event.target,
      data: {
        action: COLLECTION_SAVE_CLICK,
        label: this.isProValue ? 'Pro' : 'Free',
        content_type: `Content-${this.contentTypeValue}`,
      },
    });
  }

  findAndClickCollectionSaveButton(resourceID) {
    const resourceCollectionSaveButton = document.querySelector(`.resource-action-button--collect[data-resource-id="${resourceID}"]`);
    resourceCollectionSaveButton.click();
  }

  addToCollectionAfterLogin = () => {
    primeForPostLogin('add_collection_after_login', this.element.dataset.resourceId);

    const action = this.sessionTypeValue === 'login' ? LOGIN_TRIGGERED : JOIN_TRIGGERED;

    sendTrackingEvent({
      element: this.saveButtonTarget,
      data: { action },
    });
  }
}
